var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAccountPendingReview({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 6,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 32,
    height: 32,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0266 15.1951C24.9414 15.0745 25.877 15.1672 26.7461 15.477C45.9325 22.3122 38.8937 38.6485 25.3706 38.2282C10.3819 37.764 9.93247 16.764 24.0266 15.1951Z",
    fill: "#B29AD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3434 14.6667C18.5967 14.6656 13.127 20.133 13.1252 26.8797C13.124 33.6264 18.5914 39.0961 25.3381 39.0979C25.3399 39.0979 25.3417 39.0979 25.3434 39.0979C32.0842 39.0979 38.8618 32.3204 38.8618 25.5802C38.8618 19.3244 32.7022 14.6667 25.3434 14.6667Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1664 19.5215C25.1664 19.5215 25.2347 25.4911 25.2347 26.1061C25.2347 26.7211 25.2573 28.6807 26.0777 28.635C26.8981 28.5893 32.2527 27.8146 32.2527 27.8146",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6815 15L11.5 19.2965",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.635 15.0959L40.042 19.8709",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccountPendingReview);
export default __webpack_public_path__ + "static/media/icon-account-pending-review.d5d6794117caa1dee507d6f787eea3ed.svg";
export { ForwardRef as ReactComponent };